import { render, staticRenderFns } from "./OrganisationList.vue?vue&type=template&id=bd42836c&scoped=true"
import script from "./OrganisationList.vue?vue&type=script&lang=js"
export * from "./OrganisationList.vue?vue&type=script&lang=js"
import style0 from "./OrganisationList.vue?vue&type=style&index=0&id=bd42836c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd42836c",
  null
  
)

export default component.exports